<template>
	<div :class="showCompactBox ? 'col-md-4' : 'col-md-3'" class="col-sm-6 col-xs-12">
		<div class="milestone-box">
			<h2 class="count" :class="{ valid: item.count >= 0 }">{{ item.count }}</h2>
			<p>{{ $t('Section.MilestonesContainerBox' + item.type) }}</p>
		</div>
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'

export default {
	name: 'MilestonesContainerBox',
	mixins: [AccountInfo],
	props: {
		item: {
			type: Object,
			required: true,
		},
		compact: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		showCompactBox() {
			return this.compact
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/boxes/MilestonesContainerBox.vue